import { useMutation } from '@apollo/client';
import { ArchiveOrgUserDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { evictField } from '@/utils/graphqlUtils';

/**
 * Apollo (legacy) implementation of archive — used when the `trpc`
 * feature flag is off. Calls the `archive_org_user` Hasura action which
 * is handled by `packages/rest-api/src/handlers/user/archive-status/archive.ts`.
 *
 * `refetchQueries: ['GetAuthUsers']` is by operation name so it matches
 * the active observable regardless of variables (the Settings → Users
 * page passes a `where` filter; using a `{ query: doc }` reference
 * without variables would silently fail to match).
 */
export const useArchiveUserGraphQL = () => {
  const [mutate, state] = useMutation(ArchiveOrgUserDocument, {
    refetchQueries: ['GetAuthUsers'],
    awaitRefetchQueries: true,
    update: (cache) => {
      evictField(cache, 'auth_user');
      evictField(cache, 'auth_user_aggregate');
    },
  });

  return {
    archiveUser: async (userId: string) => {
      const result = await mutate({ variables: { userId } });
      if (!result.data?.archive_org_user) {
        throw new Error('Archive user mutation returned no data');
      }

      return result.data.archive_org_user;
    },
    loading: state.loading,
    error: state.error,
  };
};
